
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"3.193","fill":"#fff"}}),_c('path',{attrs:{"d":"M26.463 12.277l-1.616 1.69C23.55 12.736 21.847 12 20 12c-3.15 0-5.914 2.1-6.88 5.228-.182.585.126 1.214.686 1.402.566.192 1.162-.132 1.344-.716.68-2.207 2.63-3.686 4.85-3.686 1.265 0 2.433.494 3.34 1.316l-1.503 1.538c-.534.585-.144 1.58.643 1.601h4.897a.654.654 0 00.623-.665v-5.077c0-.837-.97-1.256-1.537-.664zm-.27 8.69c-.564-.19-1.162.132-1.343.716-.68 2.204-2.63 3.683-4.85 3.683-1.265 0-2.433-.493-3.34-1.315l1.473-1.539c.564-.585.174-1.58-.613-1.6h-4.898a.654.654 0 00-.622.664v5.078c0 .837.969 1.256 1.536.664l1.616-1.689c1.298 1.227 3.001 1.965 4.818 1.965 3.148 0 5.913-2.1 6.88-5.228.213-.585-.097-1.243-.657-1.4z","fill":"#000","fill-opacity":".38"}})])
          )
        }
      }
    